var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('div',{},[_c('manage-navegator'),_vm._v(" "),_c('div',{staticClass:"tab-content",staticStyle:{"padding":"20px"}},[_c('div',{},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }